function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
import regeneratorRuntime from "regenerator-runtime";
import { getAuth } from "firebase/auth";
import { kernelsClient } from "@kaggle/sdk";
export var KernelsFirestoreClient = /*#__PURE__*/ function() {
    "use strict";
    function KernelsFirestoreClient(app) {
        var _this = this;
        _classCallCheck(this, KernelsFirestoreClient);
        this.stopAllFirestoreListeners = function() {
            _this.unsubscribeFunctions.forEach(function(unsubscribe) {
                return unsubscribe();
            });
            _this.unsubscribeFunctions = [];
        };
        this.app = app;
        this.unsubscribeFunctions = [];
    }
    _createClass(KernelsFirestoreClient, [
        {
            key: "getKernelFirestoreSessionId",
            value: /** Updates auth and retrieves the firestore session id. */ function getKernelFirestoreSessionId(kernelSessionId) {
                var _this = this;
                return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                    var auth, ref, firestoreSessionId;
                    return regeneratorRuntime.wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.prev = 0;
                                auth = getAuth(_this.app);
                                _ctx.t0 = kernelsClient.kernelsService;
                                if (!auth.currentUser) {
                                    _ctx.next = 9;
                                    break;
                                }
                                _ctx.next = 6;
                                return auth.currentUser.getIdToken();
                            case 6:
                                _ctx.t1 = _ctx.sent;
                                _ctx.next = 10;
                                break;
                            case 9:
                                _ctx.t1 = undefined;
                            case 10:
                                _ctx.t2 = _ctx.t1;
                                _ctx.t3 = kernelSessionId;
                                _ctx.t4 = {
                                    firebaseIdToken: _ctx.t2,
                                    kernelRunId: _ctx.t3
                                };
                                _ctx.next = 15;
                                return _ctx.t0.updateUserKernelFirestoreAuth.call(_ctx.t0, _ctx.t4);
                            case 15:
                                ref = _ctx.sent;
                                firestoreSessionId = ref.sessionId;
                                return _ctx.abrupt("return", firestoreSessionId);
                            case 20:
                                _ctx.prev = 20;
                                _ctx.t5 = _ctx["catch"](0);
                                if (_instanceof(_ctx.t5, Error)) {
                                    _this.onError(_ctx.t5);
                                }
                            case 23:
                                return _ctx.abrupt("return", undefined);
                            case 24:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            0,
                            20
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return KernelsFirestoreClient;
}();
